import { render, staticRenderFns } from "./MessageRouter.vue?vue&type=template&id=17f65d9e&scoped=true"
import script from "./MessageRouter.vue?vue&type=script&lang=js"
export * from "./MessageRouter.vue?vue&type=script&lang=js"
import style0 from "./MessageRouter.vue?vue&type=style&index=0&id=17f65d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f65d9e",
  null
  
)

export default component.exports